export const FORCE_OVERLAY = true;

export const LOCKED = false;

export const STUDY_OVERRIDES = {
  'plot.trackprice': true,
  'overlay.extendtimescale': false,
};

export const STUDY_OPTIONS = {
  priceScale: 'new-left' as const,
};
